import React from 'react'

const Other = () => {
  return (
    <div>Other</div>
  )
}

export default Other